import {
  breakpointSizes,
  getBreakpointUp,
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import { useTranslate } from 'src/localization/Trns'
import { homeUrl, searchUrl } from 'src/navigation/urls'
import styled, { css } from 'styled-components'

interface NotFoundBottomContentProps {
  className?: string
  isSummary?: boolean
  isFlyout?: boolean
}

const ListItem = styled.li`
  ${getFontCss(
    16,
    themeConstants.colors.font_primary,
    styleConstants.fontFamilies.regular,
  )};
`

const NotFoundBottomContent: React.FC<NotFoundBottomContentProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        ${getBreakpointUp(breakpointSizes.SM)(css`
          max-width: 420px;
        `)}
      `}
    >
      {!props.isSummary && (
        <div
          css={css`
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.medium,
              )};
              margin-bottom: 16px;
            `}
          >
            {translate('The likely causes')}
          </span>
          <ul
            css={css`
              padding-left: 20px;
            `}
          >
            <ListItem>{translate('The page has moved')}</ListItem>
            <ListItem>{translate('The page no longer exists')}</ListItem>
            <ListItem>
              {translate('An incorrect URL may have been entered')}
            </ListItem>
            {!props.isFlyout && (
              <ListItem>
                {translate(
                  "You're actually trying to find our 404 page. Good job!",
                )}
              </ListItem>
            )}
            {props.isFlyout && (
              <ListItem>
                {translate(
                  "You're trying to see if we made 404 screens everywhere. Satisfied?",
                )}
              </ListItem>
            )}
          </ul>
        </div>
      )}
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        {!props.isSummary && (
          <Fragment>
            <span
              css={css`
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.medium,
                )};
                margin-bottom: 16px;
              `}
            >
              {translate('What to do')}
            </span>
            <p
              css={css`
                ${getFontCss(
                  16,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.regular,
                )};
                margin-bottom: 30px;
              `}
            >
              {translate(
                "Consider using ${search} or returning to your dashboard's ${home} to find what you need within the app.",
                {
                  search: (
                    <HoverableLink
                      to={searchUrl()}
                      size={HoverableLinkSizes.Large}
                      ariaLabelSource={'Search'}
                    >
                      {translate('Search')}
                    </HoverableLink>
                  ),
                  home: (
                    <HoverableLink
                      to={homeUrl()}
                      size={HoverableLinkSizes.Large}
                      ariaLabelSource={'Homescreen'}
                    >
                      {translate('Homescreen')}
                    </HoverableLink>
                  ),
                },
              )}
            </p>
          </Fragment>
        )}
        <p>
          {translate(
            "If you're certain that this page should exist, contact us via our ${resourceCenter}.",
            {
              resourceCenter: (
                <ResourceCenterLink size={HoverableLinkSizes.Large} underline />
              ),
            },
          )}
        </p>
      </div>
    </div>
  )
}

export default NotFoundBottomContent
